const MAX_IDEAS_ROLE_PATTERN = /^alerts::max-ideas::(\d+)$/;

/**
 * Parse the maximum allowed enabled idea alerts from a list of role strings.
 * Returns undefined if no matching role exists (meaning unlimited).
 * If multiple matching roles exist, returns the largest N.
 */
export function parseMaxIdeasFromRoles(roles: readonly string[]): number | undefined {
    let max: number | undefined;
    for (const role of roles) {
        const match = MAX_IDEAS_ROLE_PATTERN.exec(role);
        if (match) {
            const n = parseInt(match[1], 10);
            if (max === undefined || n > max) {
                max = n;
            }
        }
    }
    return max;
}

interface IdeaAlertLike {
    readonly id: string;
    readonly enabled: { readonly value: boolean };
}

/**
 * Returns true if enabling another idea alert would be allowed.
 */
export function canEnableIdeaAlert(activeCount: number, maxIdeas: number | undefined): boolean {
    if (maxIdeas === undefined) return true;
    return activeCount < maxIdeas;
}

/**
 * Walk the alert list and return IDs of enabled alerts beyond the first `maxIdeas` —
 * these should be disabled to enforce the limit.
 */
export function getIdeaAlertIdsToDisable(alerts: readonly IdeaAlertLike[], maxIdeas: number): string[] {
    let enabledCount = 0;
    const toDisable: string[] = [];

    for (const alert of alerts) {
        if (alert.enabled.value) {
            enabledCount++;
            if (enabledCount > maxIdeas) {
                toDisable.push(alert.id);
            }
        }
    }

    return toDisable;
}
